import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.deleteDevicesConfirmTitle'),
      "open": _vm.deletePrompt,
      "showSelect": _vm.isActility,
      "checkBoxLable": _vm.$i18n_t('NiotaClassic.Devices.deleteFromActility'),
      "buttons": _vm.buttons,
      "color": _vm.color
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.remove
    }
  }), _c('core-n20-dialog', {
    attrs: {
      "isOpen": true,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._t("title", function () {
          return [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.titleUpdateAll')) + "\n      ")];
        })];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "title": _vm.$i18n_t('Common.save')
          },
          on: {
            "click": _vm.save
          }
        }), _c('core-button', {
          attrs: {
            "color": "danger",
            "prepend-icon": "fa-trash-alt",
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.deleteAll')
          },
          on: {
            "click": function ($event) {
              _vm.deletePrompt = true;
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_vm.editAllFormDialog ? _c('niota-classic-devices-multiple-edit-list', {
    attrs: {
      "devices": _vm.devices
    },
    on: {
      "updateList": _vm.updateList
    }
  }) : _vm._e()], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('niota-classic-devices-edit-device-form', {
    attrs: {
      "isIotHubManager": _vm.isIotHubManager,
      "editedItem": _vm.formItem,
      "formSaving": _vm.formSaving,
      "showDeviceType": true,
      "deviceTypes": _vm.deviceTypes,
      "adrLimits": _vm.adrLimits
    },
    on: {
      "updateData": _vm.updateFormData
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.applications,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "applicationId", $$v);
      },
      expression: "formItem.applicationId"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };